import {Stage} from '../../../config/stage';

// FNP-1852: the settled bounds, the same ones the mutation enforces.
export const TEST_DATA_LIMITS = {
    count: {min: 1, max: 200, fallback: 20},
    daysBack: {min: 1, max: 365, fallback: 90}
} as const;

// Present only where the mutation can run (dev and test, and localhost, which
// talks to dev), and only for an admin, which is the mutation's own auth.
// Absent in prod: the mutation refuses there anyway, so the button would only
// ever fail.
export const canGenerateTestData = (stage: Stage, role: string | undefined) =>
    stage !== 'prod' && role === 'Admin';

export const clampInt = (
    value: string | number,
    limits: {min: number; max: number; fallback: number}
) => {
    const n = typeof value === 'number' ? value : Number.parseInt(value, 10);
    if (!Number.isFinite(n)) return limits.fallback;
    return Math.min(limits.max, Math.max(limits.min, Math.trunc(n)));
};

// Amplify rejects with {errors: [{message}]}; anything else may be an Error.
export const errorMessage = (error: unknown) => {
    const errors = (error as {errors?: {message?: string}[]})?.errors;
    if (Array.isArray(errors) && errors[0]?.message) return errors[0].message;
    if (error instanceof Error) return error.message;
    return 'Generating test data failed.';
};
